import { httpApi } from "./http.api";

export const getAnalyticsData = (): Promise<any[]> =>
  httpApi
    .get<any[]>("users/analytics/get-stats/")
    .then((data: any) => data.data);
   
